module.exports = __webpack_public_path__ + "img/text.3b951b24.png";